import { FormLabel } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import MuiInput from "@mui/material/Input";
import Slider from "@mui/material/Slider";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { useState } from "react";
import { useProyecto } from "../../data/ProyectoContext";

const Input = styled(MuiInput)`
  width: 42px;
`;

export default function DuracionHorasSemana() {
  const { proyecto, setProyecto } = useProyecto();
  const [value, setValue] = useState(12);

  const handleSliderChange = (event: Event, newValue: number | number[]) => {
    setValue(newValue as number);
    setProyecto({ ...proyecto, horas_semanales: newValue as number });
  };

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setValue(event.target.value === "" ? 1 : Number(event.target.value));
    setProyecto({ ...proyecto, horas_semanales: Number(event.target.value) });
  };

  const handleBlur = () => {
    if (value < 1) {
      setValue(1);
    } else if (value > 15) {
      setValue(15);
    }
  };

  return (
    <Box sx={{ width: "90%" }}>
      <Box sx={{ display: "flex", flexDirection: "column", pb: 1 }}>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: "1.25rem",
            color: "#336B87",
            fontWeight: "bold",
          }}
        >
          Horas semanales *
        </Typography>
        <FormLabel
          component="p"
          sx={{ fontFamily: "Montserrat", fontSize: "0.85rem", mt: 0.2 }}
        >
          Selecciona el total de horas pedagógicas que cada semana se dedicará a
          la implementación de esta planificación.
        </FormLabel>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs mt={-2.5}>
          <Slider
            value={typeof value === "number" ? value : 0}
            onChange={handleSliderChange}
            aria-labelledby="input-slider"
            color="success"
            sx={{
              ml: 2,
              width: "95%",
              color: "#336B87",
              "& .MuiSlider-markLabel": {
                color: "#336B87",
                fontFamily: "montserrat",
              },
              "& .MuiSlider-valueLabel": {
                backgroundColor: "#F9DA96",
                color: "#209099",
                fontFamily: "montserrat",
              },
            }}
            valueLabelDisplay="auto"
            defaultValue={12}
            min={1}
            max={15}
          />
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              variant="body2"
              sx={{
                cursor: "pointer",
                fontSize: "0.6rem",
                color: "rgba(0, 0, 0, 0.6)",
              }}
            >
              1 hr
            </Typography>
            <Typography
              variant="body2"
              sx={{
                cursor: "pointer",
                fontSize: "0.6rem",
                color: "rgba(0, 0, 0, 0.6)",
              }}
            >
              15 hrs
            </Typography>
          </Box>
        </Grid>
        <Grid item>
          <Input
            value={value}
            size="small"
            onChange={handleInputChange}
            onBlur={handleBlur}
            inputProps={{
              step: 1,
              min: 1,
              max: 15,
              type: "number",
              "aria-labelledby": "input-slider",
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
